import { BookOpenIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { HELP_START } from "../help/helpArticles";
import { useHelpOpener } from "../help/opening/helpOpening";
import ButtonLink from "../../ui/buttons/ButtonLink";

interface GuideLinkProps {
  /** Shown as a button, as a call to action on its own (F48); else a link styled by `className`. */
  asButton?: boolean;
  className?: string;
}

/** The help center's start (web-app.md WA-6), opened as Personal preferences say. */
export default function GuideLink({ asButton = false, className }: GuideLinkProps) {
  const { t } = useTranslation();
  const { linkProps } = useHelpOpener();
  const content = (
    <>
      <BookOpenIcon className={asButton ? "h-4 w-4" : "mr-1 inline h-4 w-4 align-[-2px]"} aria-hidden="true" />
      {t("app.guide")}
    </>
  );
  return asButton ? (
    <ButtonLink {...linkProps(HELP_START)} size="xs" className={className} title={t("app.guideTitle")}>
      {content}
    </ButtonLink>
  ) : (
    <a {...linkProps(HELP_START)} className={className} title={t("app.guideTitle")}>
      {content}
    </a>
  );
}
